import { SortTypes } from './Constants';
import _ from 'lodash';

const DataTableUtil = {};

function _toString(v) {
  if (typeof v === 'boolean' || typeof v === 'number') {
    v = String(v);
  }
  return v;
}

DataTableUtil.filterList = (
  list = [],
  filterText = '',
  filterKeys = [],
  columnSortDirs = {},
  filterTextRegExp = null,
  searchForEmptyFilterText = false
) => {
  if (list.length === 0) {
    return list;
  }
  filterText = _toString(filterText);

  let filteredList = list;
  let shouldFilterText = !_.isEmpty(filterText);
  if (searchForEmptyFilterText) {
    shouldFilterText = true;
  }
  filterTextRegExp = filterTextRegExp || new RegExp(filterText, 'i'); // case insensitive

  if (shouldFilterText) {
    filteredList = _.filter(list, (hostInfo) => {
      for (let key of filterKeys) {
        let value = _toString(hostInfo[key]);
        if (searchForEmptyFilterText) {
          if (_.isEmpty(value)) {
            return true;
          }
        } else {
          if (filterTextRegExp.test(value)) {
            return true;
          }
        }
      }
    });
  }

  // console.log('filterList:', filteredList.length, filterText, shouldFilterText, columnSortDirs, searchForEmptyFilterText);

  let dataList = filteredList;
  Object.keys(columnSortDirs).forEach((columnKey) => {
    const sortDir = columnSortDirs[columnKey];
    if (sortDir === SortTypes.ASC) {
      dataList = _.sortBy(filteredList, columnKey);
    } else if (sortDir === SortTypes.DESC) {
      dataList = _.sortBy(filteredList, columnKey).reverse();
    }
  });

  return dataList;
};

export default DataTableUtil;



// WEBPACK FOOTER //
// ./src/DataTableUtil.js